module.exports = __webpack_public_path__ + "static/media/eco8-negativ-A.6589d808.png";